import DOMPurify from 'dompurify'
import { forwardRef, useEffect } from 'react'
import { useTheme } from 'styled-components'
import { promotionalBannerVariants } from '@velasca/constants'
import { useSessionStorage } from '@velasca/hooks/use-session-storage'
import { CloseIcon } from '@velasca/icons/close'
import type { PromotionalBannerProps } from '@velasca/types'
import { IconButton } from '@velasca/ui/icon-button'
import * as S from './styles'

const PromotionalBanner = forwardRef<
  HTMLDivElement | null,
  PromotionalBannerProps
>(
  (
    { text, hideCloseButton, variant = promotionalBannerVariants.PRIMARY },
    ref,
  ) => {
    useEffect(() => {
      const promotionalBannerSkeletonEl = document.querySelector<HTMLElement>(
        '#promotional-banner-skeleton',
      )

      if (promotionalBannerSkeletonEl) {
        promotionalBannerSkeletonEl.classList.add('react-loaded')
      }
    }, [])

    const [isBannerShown, setBannerShown] = useSessionStorage<boolean>(
      'promotional-banner-status',
      'true',
    )

    const theme = useTheme()

    if (!text || !isBannerShown) {
      return null
    }

    const { mobile, desktop } = text

    if (mobile && mobile !== '' && desktop && desktop !== '') {
      return (
        <S.PromotionalBanner variant={variant} ref={ref}>
          {mobile !== '' && (
            <S.MobileMessage
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mobile) }}
            />
          )}

          {desktop !== '' && (
            <S.DesktopMessage
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(desktop),
              }}
            />
          )}
          {!hideCloseButton && (
            <S.CloseButton>
              <IconButton
                clickAreaSize="3.2rem"
                color={theme.colors.background}
                onClick={() => {
                  setBannerShown(false)
                }}
              >
                <CloseIcon />
              </IconButton>
            </S.CloseButton>
          )}
        </S.PromotionalBanner>
      )
    }

    return null
  },
)

export default PromotionalBanner
